import { useMutation } from 'react-query';
import { roleApi } from '../../api';

export const useDeleteRole = () => {
  const mutation = useMutation((id: number): any => {
    return roleApi.delete(id);
  });
  return mutation;
};
